import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  DEFAULT_PROCESSING_FEE_PERCENT,
  DEFAULT_SALES_TAX_PERCENT,
} from "../../utils/museumFeeTax";
import { fetchMuseumFeeTaxSettings } from "../../services/museumService";

export type MuseumState = {
  processingFeePercent: number;
  salesTaxPercent: number;
  loaded: boolean;
  loading: boolean;
};

const initialState: MuseumState = {
  processingFeePercent: DEFAULT_PROCESSING_FEE_PERCENT,
  salesTaxPercent: DEFAULT_SALES_TAX_PERCENT,
  loaded: false,
  loading: false,
};

export const loadMuseumFeeTax = createAsyncThunk(
  "museum/loadMuseumFeeTax",
  async () => fetchMuseumFeeTaxSettings()
);

const museumSlice = createSlice({
  name: "museum",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadMuseumFeeTax.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadMuseumFeeTax.fulfilled, (state, action) => {
        state.processingFeePercent =
          action.payload.processingFeePercent >= 0
            ? action.payload.processingFeePercent
            : DEFAULT_PROCESSING_FEE_PERCENT;
        state.salesTaxPercent =
          action.payload.salesTaxPercent >= 0
            ? action.payload.salesTaxPercent
            : DEFAULT_SALES_TAX_PERCENT;
        state.loaded = true;
        state.loading = false;
      })
      .addCase(loadMuseumFeeTax.rejected, (state) => {
        state.processingFeePercent = DEFAULT_PROCESSING_FEE_PERCENT;
        state.salesTaxPercent = DEFAULT_SALES_TAX_PERCENT;
        state.loaded = true;
        state.loading = false;
      });
  },
});

export default museumSlice.reducer;
